import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
    full: 'max-w-[95vw]'
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm" 
        onClick={onClose}
      />
      
      <div className={cn(
        'relative w-full mx-4 rounded-xl border shadow-2xl',
        'bg-[var(--surface-elevated)] border-[var(--border)]',
        'max-h-[90vh] overflow-y-auto',
        'animate-in fade-in zoom-in-95 duration-200',
        sizes[size]
      )}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--border)] sticky top-0 bg-[var(--surface-elevated)] z-10">
          <h2 className="text-lg font-medium tracking-tight text-[var(--text-primary)]">{title}</h2>
          <button
            onClick={onClose}
            className="text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors p-1 rounded-md hover:bg-[var(--surface-hover)]"
            data-testid="modal-close"
          >
            <X size={18} />
          </button>
        </div>
        
        <div className="px-6 py-5">
          {children}
        </div>
      </div>
    </div>
  );
};
